module.exports = __webpack_public_path__ + "static/img/15.adcfe62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/15.png
// module id = WT+n
// module chunks = 1